export function loadVisibleColumns(storageKey, headers) {
  const stored = localStorage.getItem(storageKey);
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) return parsed;
    } catch (e) {}
  }
  return headers.filter(h => h.togglable).map(h => h.value);
}
